import React from 'react'
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap'

const SupportLink = () => <>
    <Button data-testid="condominium-button-chat" tag={Link} to='/dashboard/support' color="link" size="sm" className="pl-0 mt-2">
        ¿Tienes alguna pregunta? Contacta con nosotros.
    </Button>
</>

export default SupportLink;